import React, { Component } from "react";
import { connect } from "react-redux";
import { Box, Theme, Grid } from '@material-ui/core/';
import * as actions from "../../../../store/actions/index";
import { withStyles } from '@material-ui/core/styles'
import {Styles} from "@material-ui/core/styles/withStyles";
import {Helmet} from "react-helmet";
import CustomSnackBar from '../../creator/experienceManager/participantsDashboard/component/CustomSnackBar';
import * as ImmersionGQL from "../../../../gql";
import Config from "../../../../config/config";


const useStyles: Styles<Theme, any, any> = () =>({
  appBar: {
    position: 'relative',
    background: 'none',
    boxShadow: 'none',
  },
  toolBar: {
    minHeight: 50,
  },
  layout: {
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingTop:'0',
    paddingLeft: '20px',
    paddingRight: '20px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    background: '#d7d7d7',
    width: '100vw',
    backgroundImage: 'url(/assets/images/known/celebrate_header.png)',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center bottom'
  },
  label: {
    "&$focusedLabel": {
      color: "#393c41"
    },
    "&$erroredLabel": {
      color: "#393c41"
    }
  },
  focusedLabel: {},
  erroredLabel: {},
  underline: {
    fontSize: 14,
    fontFamily: 'roboto-regular',
    color: '#393c41',
    "&$error:after": {
      borderBottomColor: "#3177d8"
    },
    "&:after": {
      borderBottom: `2px solid #3177d8`
    }
  },

  registerlogocontainer:{
    textAlign:"left", 
    marginTop:"22px", 
    marginLeft:"40px",
    '@media (max-width: 768px)': {
      margin:"0 auto",
      marginTop:"20px",
      textAlign:"center", 
      width:"100%"
    },
  },
  registerLogo:{
    width: "188px",
    height: "27px",
    '@media (max-width: 768px)': {
      width:"100%"
    },
  },
  emailLogo:{
    width:"180px"
  },
  description:{
    textAlign: "center",
    font: "normal normal normal 24px/32px Roboto",
    color: "#393c41"
  },
  strongdescription:{
    font: "normal normal bold 24px/32px Roboto",
    color: "#393c41"
  },
  resenddescription:{
    font: "normal normal 300 18px/32px Roboto",
    color: "#393c41",
    marginBottom:"0"
  },
  resendlink:{
    font: "normal normal bold 18px/32px Roboto",
    color: "#3177d8",
    textDecoration: 'underline',
    marginTop:"0",
    cursor:"pointer",
    marginBottom:"0"
  },

  textCenter: {
    textAlign: 'center',
    color: '#393c41'
  },
  headline: {
    '@media (max-width: 960px)': {
      fontSize: '3.5rem',
    },
    '@media (max-width: 600px)': {
      fontSize: '2.5rem',
    },
  },
  logoFont: {
    fontFamily: 'Pacifico',
    color: '#3177d8'
  },
  smallText: {
    color: '#393c41'
  },
  actionButtons: {
    minWidth: '460px',
    marginBottom: '20px',
    '@media (max-width: 760px)': {
      minWidth: '250px'
    },
  },
  loginForm: {
    paddingTop: '20'
  },
  mainDiv: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },



  //general
  bottomleft:{
    textAlign:"left",
    '@media (max-width: 960px)': {
      textAlign:"center"
    },
  },
  bottomimageleft:{
    width: "354px",
    height: "161px",
    marginTop:"140px",
    marginLeft:"30px",
    '@media (max-width: 767px)': {
      margin:"0 auto",
      maxWidth: "354px",
      width:"100%"
    },
  },
  bottomright:{
    textAlign:"right",
    '@media (max-width: 960px)': {
      textAlign:"center",
    },
  },
  bottomimageright:{
    width: "374px",
    // height: "260px",
    marginRight:"30px",
    '@media (min-width: 768px) and (max-width:992px)': {
      marginRight:"0",
    },
    '@media (max-width: 767px)': {
      margin:"0 auto",
      width:"100%",
      maxWidth: "374px",
    },
  },

  error: {}
});

interface IProps {
  userInfo: any,
  apolloClient: any,
  classes: any,
  notification: any,
  history: any,
  match: any,
  ResendLink: (client: any, request: any) => void,
  registerUser: (client: any, requestData: any, history: any, match: any) => void
}

interface IState {
  email: string,
  billingSessionId: string,
  loading: boolean,
  snackAlertType:string,
  snackAlertMsg:string,
  isShownSnackAlert:boolean,
  customerName: string,
  billingSession: any,
  billingCustomer: any,
  billingPrice: any,
  billingProduct: any,
  billingSubscription: any,
}

class BillingSuccess extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      email: "-",
      loading: false,
      billingSessionId: "",
      customerName: "",
      billingSession: null,
      billingCustomer: null,
      billingPrice: null,
      billingProduct: null,
      billingSubscription: null,
      snackAlertType:"success",
      snackAlertMsg:"",
      isShownSnackAlert:false
    };
  }

  // load int actions
  componentDidMount() {
    const queryString = require('query-string');
 
    const parsed = queryString.parse(location.search);
    //console.log(parsed);
    //setBillingSessionId(parsed.session_id);
    // const location = useLocation();
    //console.log(billingSessionId);


    this.setState(
      { 
        email: this.props.userInfo.email,
        billingSessionId: parsed.session_id
       }, () => { this.forceUpdate(); }
    );


    this.checkSessionData(parsed.session_id);




  }


  checkSessionData = (sessionId: string) => {
    this.props.apolloClient.client.query({
        query: ImmersionGQL.getStripeCheckoutSessionData,
        fetchPolicy: "no-cache",
        variables: {
          sessionid: sessionId,
        }
      })
      .then((response: any) => {
        //console.log(response);
        if (response.data.getStripeCheckoutSessionData.status === "true") {
          //console.log("have a valid billing session");
          this.setState(
            {
            billingSession: response.data.getStripeCheckoutSessionData.data.session,
            billingCustomer: response.data.getStripeCheckoutSessionData.data.customer,
            billingPrice: response.data.getStripeCheckoutSessionData.data.price,
            billingProduct: response.data.getStripeCheckoutSessionData.data.product,
            billingSubscription: response.data.getStripeCheckoutSessionData.data.subscription,
            customerName: response.data.getStripeCheckoutSessionData.data.customer.name
            }, () => { this.doRegister(); }
          );
        }
        //  window.location.href = response.data.getStripeCheckoutSession.data.url;
        //}


        



      });
  }

  doRegister = () => {
    //do register user
    //console.log("start doRegister");

    let first_name = "";
    let last_name = "";

    if (this.state.billingCustomer.name.includes(' ')) {
      const name = this.state.billingCustomer.name.split(' ');
      first_name = name[0];
      last_name = this.state.billingCustomer.name.substring(name[0].length).trim();
    }

    const requestData = {
      email: this.state.billingCustomer.email,
      billing_subscription_id: this.state.billingSubscription.id,
      billing_customer_id: this.state.billingCustomer.id,
      billing_price_id: this.state.billingPrice.id,
      billing_product_id: this.state.billingProduct.id,
      billing_product_name: this.state.billingProduct.name,
      billing_customer_name: this.state.billingCustomer.name,
      fname: first_name,
      lname: last_name,
      billing_member_qty: 1,
      prepaid: true
    };

    //console.log(requestData);
    try {
      this.props.registerUser(this.props.apolloClient.client, requestData, this.props.history, this.props.match);
    } catch (e) {
      console.log(e);
    }
  }

  UNSAFE_componentWillReceiveProps(props: IProps) {
    if (props.notification) {
      this.setState({
        email: this.props.userInfo.email,
        loading: false
      })
      if(props.notification.success){
       this.setState({
        snackAlertMsg:"Email sent sucessfully.",
        isShownSnackAlert:true
       })   
      } else {
        this.setState({
          snackAlertType:"error",
          snackAlertMsg:"Problem occured while send email.",
          isShownSnackAlert:true
         })   
      }
    }
  }

  // resend link
  resendLink = () => {
    if (this.props.userInfo.email) {
      this.setState({ loading: true });
      const request = {
        email: this.props.userInfo.email,
        brand: Config.DEFAULT_SUBBRAND,
      };
      this.props.ResendLink(this.props.apolloClient.client, request)
    }
  };

  hideSnackAlert = () => {
    this.setState({
      isShownSnackAlert:false
    })
  }

  render() {
    const { classes } = this.props;
    const { billingSessionId } = this.state;
    console.log(billingSessionId);

    return (
      <React.Fragment>
        <Helmet title="Confirm Email"/>
        
        <div className={classes.layout}>

        <Grid container spacing={3}>
              <Grid item xs={12} sm={6} >

          <Box className={classes.mainDiv}>
            <div className="login-form" style={{maxWidth:"unset"}}>
             

            </div>
          </Box>
          </Grid>
              </Grid>

        </div>
        
        <CustomSnackBar type={this.state.snackAlertType} message={this.state.snackAlertMsg} open={this.state.isShownSnackAlert} onClose={this.hideSnackAlert} />
      </React.Fragment>
    );
  }
}

// load reducers
const mapStateToProps = (state: any) => {
  const { userInfo } = state.authUser;
  return {
    userInfo,
    apolloClient: state.apolloClient,
    notification: state.notification
  };
};

// load actions
const mapDispatchToProps = (dispatch: any) => {
  return {
    ResendLink: (client: any, request: any) => { 
      dispatch(actions.ResendLink(client, request)); 
    },

    registerUser: (client: any, request: any, history: any) => {
      dispatch(actions.registerUser(client, request, history));
    },
  }
};

const BillingSuccessComponent = withStyles(useStyles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(BillingSuccess));

export {
  BillingSuccessComponent
}
